import * as React from 'react';
import * as icons from './Icons';
import { OverrideComponent } from '../renderProps';
const overridedIcons = {};
Object.entries(icons).forEach(([name, icon]) => {
    overridedIcons[name] = React.createElement(OverrideComponent, { componentProps: null, component: { [name]: () => icon } });
});
export { overridedIcons };
export * from './Icons';
